<div class="health-indicator">
	<div class="status-text">
		{{healthText}}
		<div class="circle status-blank-bg" [class]="backgroundClass(overallHealth)">
			<i [class]="iconClass"></i>
		</div>
	</div>
	<div *ngIf="fleet.assets && fleet.assets.length > 0">
		<div class="status-bars">
			<div *ngIf="api.user.hide_rtb !== 1 && !allFixed" class="bar status-blank-bg" [class]="backgroundClass(rtbHealth)"></div>
			<div *ngIf="api.user.hide_fdm !== 1 && !allFixed" class="bar status-blank-bg" [class]="backgroundClass(fdmHealth)"></div>
			<div *ngIf="api.user.hide_mech !== 1" class="bar status-blank-bg" [class]="backgroundClass(mdHealth)"></div>
		</div>
		<div class="status-bars">
			<div *ngIf="api.user.hide_rtb !== 1 && !allFixed" class="health-badge">RTB</div>
			<div *ngIf="api.user.hide_fdm !== 1 && !allFixed" class="health-badge">FDM</div>
			<div *ngIf="api.user.hide_mech !== 1" class="health-badge">MD</div>
		</div>
	</div>
</div>